import { CreditCardIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';

export const rows = [
  { content: '6 Tomos digitales completos (240 fichas)', value: '97€' },
  { content: '6 Bonos exclusivos', value: '114€' }
];

export const trustItems = [
  { icon: CreditCardIcon, label: 'Pago único' },
  { icon: ZapIcon, label: 'Acceso inmediato' },
  { icon: ShieldCheckIcon, label: 'Garantía 7 días' }
];
